import axios from 'axios';
// import Vue from 'vue';
// import useCookies from 'vue3-cookies';

export default {
  // setup() {
  //   const { cookies } = useCookies();
  //   return { cookies };
  // },
  async login(context, loginViewModel) {
    await axios
      .post(
        `${context.rootState.apiBaseURL}/Security/Account/LoginWebsite`,
        loginViewModel
      )
      .then((response) => {
        if (response.data === 'TwoFactorAuthentication') {
          return Promise.reject(response.data);
        }
        if (response.data.clients && response.data.clients.length > 1) {
          return Promise.reject(response);
        } else {
          context.dispatch('setStorageAndSetterItems', {
            token: response.data.token,
            refreshToken: response.data.refreshToken,
            userID: response.data.userID,
            firstName: response.data.clients[0].firstName,
            lastName: response.data.clients[0].lastName,
            requireChangePassword: response.data.requireChangePassword,
            userName: response.data.userName,
            lastLoginDateTime: response.data.lastLoginDateTime,
            isPartTime: response.data.clients[0].isPartTime,
            personID: response.data.clients[0].personID,
            hasUnseenMessage: response.data.clients[0].hasUnseenMessage,
          });
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async loginWithOTP(context, otpViewModel) {
    await axios
      .post(
        `${context.rootState.apiBaseURL}/Security/Account/VerifyOTPForLogin`,
        otpViewModel
      )
      .then((response) => {
        if (response.data === 'TwoFactorAuthentication') {
          return Promise.reject(response.data);
        }
        if (response.data?.success === false) {
          return Promise.reject(response);
        }
        if (response.data.clients && response.data.clients.length > 1) {
          return Promise.reject(response);
        } else {
          context.dispatch('setStorageAndSetterItems', {
            token: response.data.token,
            refreshToken: response.data.refreshToken,
            userID: response.data.userID,
            firstName: response.data.clients[0].firstName,
            lastName: response.data.clients[0].lastName,
            requireChangePassword: response.data.requireChangePassword,
            userName: response.data.userName,
            lastLoginDateTime: response.data.lastLoginDateTime,
            isPartTime: response.data.clients[0].isPartTime,
            personID: response.data.clients[0].personID,
            hasUnseenMessage: response.data.clients[0].hasUnseenMessage,
          });
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async loginTwoFactorAuthentication(context, loginViewModel) {
    await axios
      .post(
        `${context.rootState.apiBaseURL}/Security/Account/VerifyCodeForSite`,
        loginViewModel
      )
      .then((response) => {
        if (response.data.clients.length > 1) {
          return Promise.reject(response);
        }
        context.dispatch('setStorageAndSetterItems', {
          token: response.data.token,
          refreshToken: response.data.refreshToken,
          userID: response.data.userID,
          firstName: response.data.clients[0].firstName,
          lastName: response.data.clients[0].lastName,
          requireChangePassword: response.data.requireChangePassword,
          userName: response.data.userName,
          lastLoginDateTime: response.data.lastLoginDateTime,
          isPartTime: response.data.clients[0].isPartTime,
          personID: response.data.clients[0].personID,
          hasUnseenMessage: response.data.clients[0].hasUnseenMessage,
        });
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async logout(context) {
    // eslint-disable-next-line
    removeCookie('token');
    // eslint-disable-next-line
    removeCookie('refreshToken');
    localStorage.clear();
    sessionStorage.clear();
    context.commit('setUser', {
      token: null,
      refreshToken: null,
      userID: null,
      firstName: null,
      lastName: null,
      requireChangePassword: null,
      userName: null,
      lastLoginDateTime: null,
      isPartTime: null,
      personID: null,
      hasUnseenMessage: null,
    });
    await axios.post(`${context.rootState.apiBaseURL}/Security/Account/Logout`);
  },
  async refreshToken(context) {
    let tokenObject = new Object();
    // eslint-disable-next-line
    tokenObject.token = getCookie('token');
    // eslint-disable-next-line
    tokenObject.refreshToken = getCookie('refreshToken');

    await axios
      .post(
        `${context.rootState.apiBaseURL}/Security/RefreshToken/Refresh`,
        tokenObject,
        {
          headers: {},
        }
      )
      .then((response) => {
        context.commit('setRefreshTokenData', {
          token: response.data.token,
          refreshToken: response.data.refreshToken,
        });
        // eslint-disable-next-line
        setCookie('token', response.data.token, 1);
        // eslint-disable-next-line
        setCookie('refreshToken', response.data.refreshToken, 1);

        // localStorage.setItem('token', response.data.token);
        // localStorage.setItem('refreshToken', response.data.refreshToken);
        axios.defaults.headers.common = {
          Authorization: `Bearer ${response.data.token}`,
        };
        // alert('request send!');
      })
      .catch(() => {
        context.dispatch('logout');
      });
  },

  setStorageAndSetterItems(context, data) {
    // eslint-disable-next-line
    setCookie('token', data.token, 1);
    // eslint-disable-next-line
    setCookie('refreshToken', data.refreshToken, 1);
    // localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('userID', data.userID);
    localStorage.setItem('personID', data.personID);
    localStorage.setItem('firstName', data.firstName);
    localStorage.setItem('lastName', data.lastName);
    localStorage.setItem('userName', data.userName);
    localStorage.setItem('isPartTime', data.isPartTime);
    localStorage.setItem('lastLoginDateTime', data.lastLoginDateTime);
    localStorage.setItem('requireChangePassword', data.requireChangePassword);
    localStorage.setItem('hasUnseenMessage', data.hasUnseenMessage);
    context.commit('setUser', {
      token: data.token,
      refreshToken: data.refreshToken,
      userID: data.userID,
      firstName: data.firstName,
      lastName: data.lastName,
      requireChangePassword: data.requireChangePassword,
      userName: data.userName,
      lastLoginDateTime: data.lastLoginDateTime,
      isPartTime: data.isPartTime,
      personID: data.personID,
      hasUnseenMessage: data.hasUnseenMessage,
    });
    axios.defaults.headers.common = {
      Authorization: `Bearer ${data.token}`,
    };
  },

  setChangeClient(context, data) {
    localStorage.setItem('personID', data.personID);
    localStorage.setItem('firstName', data.firstName);
    localStorage.setItem('lastName', data.lastName);
    localStorage.setItem('isPartTime', data.isPartTime);
    localStorage.setItem('hasUnseenMessage', data.hasUnseenMessage);

    context.commit('changeClient', {
      personID: data.personID,
      firstName: data.firstName,
      lastName: data.lastName,
      isPartTime: data.isPartTime,
      hasUnseenMessage: data.hasUnseenMessage,
    });
  },
  setHasUnseenMessage(context, data) {
    let client = context.getters.clientList.filter(
      (f) => f.personID == data.personID
    );
    if (client && client.length > 0) {
      client[0].hasUnseenMessage = data.hasUnseenMessage;
    }
    localStorage.setItem('hasUnseenMessage', data.hasUnseenMessage);
    context.commit('changeUnseenMessage', data.hasUnseenMessage);
  },
};
